import "./dropdown-grid.css";

import classnames from "classnames";
import { ArrowDown } from "./svg";
import { Ref, useRef } from "react";

interface IDropdownGridProps {
  defaultValue: any;
  data: any[];
  onChange: (value: any, index: number) => void;
}

function DropdownGrid(props: IDropdownGridProps) {
  const dropdown: Ref<any> = useRef(null);
  const arrow: Ref<any> = useRef(null);
  const menu: Ref<any> = useRef(null);
  const selectedValue: Ref<any> = useRef(null);
  const items: any[] = [];
  let selectedIndex = 0;
  let isOpen = false;

  const render = () => {
    const { defaultValue } = props;

    const touchEvent = "ontouchstart" in window ? "touchstart" : "click";
    document.addEventListener(touchEvent, handleOutsideClick);

    return (
      <div className="dropdown-grid" ref={dropdown}>
        <div className="clickable-area" onClick={dropdownClick}>
          <div className="selected-value" ref={selectedValue}>
            {defaultValue}
          </div>
          <div className="arrow" ref={arrow}>
            <ArrowDown />
          </div>
        </div>
        <div className="menu" ref={menu}>
          {DrawColumn(0)}
          {DrawColumn(1)}
          {DrawColumn(2)}
        </div>
      </div>
    );
  };

  const DrawColumn = (index: number) => {
    const rowIndexStart = 4 * index;

    return (
      <div className={`menu-col`}>
        {DrawItem(rowIndexStart)}
        {DrawItem(rowIndexStart + 1)}
        {DrawItem(rowIndexStart + 2)}
        {DrawItem(rowIndexStart + 3)}
      </div>
    );
  };

  const DrawItem = (index: number) => {
    const { defaultValue, data } = props;
    const selected = data[index] === defaultValue;
    if (selected) {
      selectedIndex = index;
    }

    const itemRef = useRef(null);
    items[index] = itemRef;

    return (
      <div
        className={classnames(`menu-item`, {
          selected: selected,
        })}
        ref={itemRef}
        onClick={() => clickItem(index)}
      >
        {data[index]}
      </div>
    );
  };

  const clickItem = (index: number) => {
    closeDropdown();

    const { data, onChange } = props;
    items[selectedIndex].current.classList.remove("selected");
    items[index].current.classList.add("selected");
    selectedValue.current.innerText = data[index];
    selectedIndex = index;

    onChange(data[index], index);
  };

  const dropdownClick = () => {
    if (isOpen) {
      closeDropdown();
      return;
    }
    openDropdown();
  };

  const openDropdown = () => {
    if (areReferencesNotSet()) {
      return;
    }

    arrow.current.classList.remove("initial");
    arrow.current.classList.add("rotate");
    menu.current.classList.remove("hide");
    menu.current.classList.add("show");

    isOpen = true;
    menu.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  };

  const closeDropdown = () => {
    if (areReferencesNotSet()) {
      return;
    }

    arrow.current.classList.remove("rotate");
    arrow.current.classList.add("initial");
    menu.current.classList.remove("show");
    menu.current.classList.add("hide");

    isOpen = false;
  };

  const areReferencesNotSet = () => {
    return !arrow || !menu || !selectedValue || !dropdown;
  };

  const handleOutsideClick = (event: any) => {
    if (!isOpen) {
      return;
    }
    if (!dropdown.current.contains(event.target)) {
      closeDropdown();
    }
  };

  return render();
}

export default DropdownGrid;
